<template>
    <!-- 查看物流进度弹框 -->
    <div>
        <el-dialog :visible.sync="sfProgressOption.visible" title="查看物流进度" width="700px"
            @closed="sfProgressOption.dataMap = []">
            <div v-if="checkItem">
                <div v-for="(item, index) in sfProgressOption.dataMap" :key="index">
                    <div v-if="item.length">
                        <div class="danhao"><b> 运单号 : {{ item[0].logisticsNumber }}</b></div>
                        <el-timeline>
                            <el-timeline-item :color="`#cd1231`" :timestamp="(bill.locationTime).toString()" hide-timestamp
                                v-for="(bill, index) in item" :key="index">
                                <span>{{ bill.locationTime | parseTime('{y}-{m}-{d}') }}</span>
                                <span class="small">{{ bill.locationTime | parseTime('{h}:{i}:{s}') }}</span>
                                <span>{{ bill.locationDesc }}</span>
                            </el-timeline-item>
                        </el-timeline>
                    </div>
                </div>
            </div>
            <template v-else>
                {{ sfProgressOption.hasInfo }}
            </template>
        </el-dialog>
    </div>
</template>
<script>
import { commonUtils } from '@/utils/common'

export default {
    name: 'logistics-track-dialing',
    data() {
        return {
            sfProgressOption: {
                dataMap: [],
                hasInfo: '暂无物流信息',
                visible: false,
            },
        }
    },
    computed: {
        checkItem() {
            if (this.sfProgressOption.dataMap.length) {
                for (let i = 0; i < this.sfProgressOption.dataMap.length; i++) {
                    if (this.sfProgressOption.dataMap[i].length > 0) {
                        return true;
                    }
                }
            }
            return false;
        },
    },
    methods: {
        sfProgressOptionDialogShow(item) {
            let params = {
                srcNumber: item
            }
            this.sfProgressOption.visible = true
            this.$store.dispatch('getAllLogisticsTrack', params).then(res => {
                if (res.data.resultCode === '0') {
                    const { dataMap } = res.data.resultData
                    let hasOwnProperty = Object.prototype.hasOwnProperty;
                    for (const key in dataMap) {
                        if (hasOwnProperty.call(dataMap, key)) {
                            const element = dataMap[key];
                            this.sfProgressOption.dataMap.push(element)
                        }
                    }
                    this.sfProgressOption.dataMap = this.sfProgressOption.dataMap.reverse()
                }
            })
        }
    }
}

</script>
 
<style lang="scss" scoped>
::v-deep .el-dialog__body {
    // background-color: #f3f5f9;
    max-height: 400px;
    min-height: 300px;
    overflow-y: auto;
    box-sizing: border-box;
    padding: 20px 15px 15px 20px;
}

// ::-webkit-scrollbar {
//     width: 0;
// }

::v-deep .el-timeline-item__tail {
    border-left: 2px solid rgb(205, 18, 49) !important;
}

// 
.danhao {
    margin: 0px 0px 20px 30px;
}

.small {
    font-size: 13px;
    color: #575757;
    margin-left: 10px;
    margin-right: 25px;
}
</style>
